import { useState } from "react";
import { useData } from "@/context/data-provider";
import { PERIOD_PRESETS } from "@/lib/constants";

export default function Periodo() {
  const { period: { period, history, setPeriod } } = useData();
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [feedback, setFeedback] = useState(false);

  const applyCustom = () => {
    if (customStart && customEnd && customStart <= customEnd) {
      setPeriod({ start: customStart, end: customEnd });
      setCustomStart(""); setCustomEnd("");
      flash();
    }
  };

  const applyPreset = (p: { start: string; end: string }) => {
    setPeriod(p);
    flash();
  };

  const flash = () => { setFeedback(true); setTimeout(() => setFeedback(false), 2000); };

  const daysRemaining = Math.max(0, Math.ceil((new Date(period.end).getTime() - Date.now()) / 86400000));

  return (
    <div className="container">
      <h1 className="font-serif text-[1.3rem] mb-4" style={{ color: "var(--mv-ink-dark)" }}>Período</h1>

      {/* Active period */}
      <div className="period-banner mb-4">
        <span className="font-mono text-[0.58rem] uppercase tracking-widest" style={{ color: "var(--mv-ink-light)" }}>Período Ativo</span>
        <span className="font-serif text-[0.95rem]" style={{ color: "var(--mv-ink-dark)" }}>{period.start} — {period.end}</span>
        <span className="font-mono text-[0.68rem] ml-auto" style={{ color: "var(--mv-ink-light)" }}>{daysRemaining} dias restantes</span>
      </div>

      <div className="mv-panel p-[22px] max-w-[640px] mb-4" style={{ border: "1px solid var(--mv-border)", borderRadius: 12, boxShadow: "0 1px 5px var(--mv-shadow)", background: "var(--mv-surface)" }}>
        <div className="mv-label mb-[9px]">Períodos Pré-definidos</div>
        <div className="flex gap-[7px] flex-wrap mb-4">
          {PERIOD_PRESETS.map((preset) => {
            const p = preset.fn();
            const isActive = p.start === period.start && p.end === period.end;
            return (
              <button
                key={preset.label}
                className={`preset-btn ${isActive ? "active-preset" : ""}`}
                onClick={() => applyPreset(p)}
              >
                {preset.label}
              </button>
            );
          })}
        </div>

        <hr className="border-none my-[14px]" style={{ borderTop: "1px solid var(--mv-border)" }} />

        <div className="mv-label mb-[10px]">Período Personalizado</div>
        <div className="grid grid-cols-2 gap-[9px] max-w-[380px]">
          <div>
            <label className="mv-label">Data de Início</label>
            <input type="date" className="mv-input" value={customStart} onChange={(e) => setCustomStart(e.target.value)} />
          </div>
          <div>
            <label className="mv-label">Data de Fim</label>
            <input type="date" className="mv-input" value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} />
          </div>
        </div>
        <div className="mt-[14px] flex gap-[10px] items-center">
          <button className="mv-btn mv-btn-primary" onClick={applyCustom} disabled={!customStart || !customEnd}>✓ Aplicar Período</button>
          {feedback && <span className="text-[0.76rem]" style={{ color: "var(--mv-green)" }}>✓ Período aplicado!</span>}
        </div>
      </div>

      {/* History */}
      {history.length > 0 && (
        <div className="mv-panel max-w-[640px]">
          <div className="mv-panel-header">
            <span className="mv-panel-title">Histórico</span>
            <span className="mv-badge">{history.length}</span>
          </div>
          <div>
            {history.map((h, i) => {
              const isActive = h.start === period.start && h.end === period.end;
              return (
                <div
                  key={i}
                  className="p-[11px_14px] mb-[7px] mx-[10px] rounded-lg flex items-center gap-[10px] cursor-pointer transition-all"
                  style={{
                    background: isActive ? "var(--mv-blue-light)" : "var(--mv-surface2)",
                    border: isActive ? "1.5px solid var(--mv-blue)" : "1.5px solid transparent",
                  }}
                  onClick={() => applyPreset(h)}
                >
                  <span className="font-mono text-[0.72rem]" style={{ color: "var(--mv-ink-dark)" }}>{h.start} — {h.end}</span>
                  {isActive && <span className="ctag ctag-ok ml-auto">Ativo</span>}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
